export default __webpack_public_path__ + "static/media/nft.bc1a78c8.gif";